import script from "./homeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./homeView.vue?vue&type=script&setup=true&lang=ts"

import "./homeView.vue?vue&type=style&index=0&id=28dfc1f0&lang=less"

const __exports__ = script;

export default __exports__